<template>
  <div
    :id="`toast-${uid}`"
    class="toast fade m-auto mb-1 mb-md-3 ms-md-auto me-md-3"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    data-bs-delay="15000"
  >
    <div class="custom-toast-body cow-toast-success">
      <strong class="me-auto">{{ message }}</strong>
      <button
        type="button"
        class="btn-close me-1"
        data-bs-dismiss="toast"
        aria-label="Close"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import Toast from 'bootstrap/js/dist/toast';
import { useUid } from '@app/composables/useUid';

defineProps<{
  message: string;
}>();

const uid = useUid();

onMounted(() => {
  const toast = document.getElementById(`toast-${uid}`);
  if (toast) {
    // eslint-disable-next-line no-new
    new Toast(toast).show();
  }
});
</script>

<style scoped>
.custom-toast-body {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  border-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}

.cow-toast-success {
  background-color: var(--cow-success-subtle);
  color: var(--cow-text-primary);
  border-left: 4px solid var(--cow-success);
}
</style>
